export default {
  props: ['page', 'show-password-field', 'offset-top'],
};
